import { RootState } from 'redux/rootReducer';
import { EntityTypes } from 'context/entityContext';

export default getArtistIdsByEntityIds;

/**
 * Returns the id for the artist of every entity.
 *
 */
function getArtistIdsByEntityIds(
  state: RootState,
  context: { entityIds: string[]; entityType?: EntityTypes }
): string[] | undefined {
  const { entityIds, entityType } = context;
  if (!entityType) return undefined;
  if (entityType === 'artist') return entityIds;

  const entitiesOfType: any = state.entity.byId[entityType];

  const artistIds: string[] = [];

  for (const id of entityIds) {
    if (entitiesOfType[id]?.entity) {
      artistIds.push(entitiesOfType[id].entity.primaryArtist.id);
    }
  }

  /** Only return the artistIds if all entities are loaded */
  return artistIds.length === entityIds.length ? artistIds : undefined;
}
